import { Form, Modal } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import HButton from "../../atoms/HButton";
import "./FormModal.scss";

function FormModal({
  children,
  visible,
  onClose,
  headerBg = "bg-primary-500",
  title,
  subTitle,
  onSubmit,
}) {
  const { t } = useTranslation();
  return (
    <Modal
      title={null}
      visible={visible}
      onCancel={onClose}
      closable={false}
      footer={null}
      className="form-modal-wrapper"
      style={{ overflow: "visible" }}
      modalRender={(node) => <div style={{ overflow: "visible" }}>{node}</div>}
    >
      <div
        className="align-bottom bg-white text-left shadow-xl"
        style={{ overflow: "visible" }}
      >
        <button
          className="absolute right-2 m-3 p-3 text-white text-opacity-80 hover:text-opacity-100 text-xl"
          onClick={onClose}
        >
          <i className="far fa-times" />
        </button>

        <div className={"w-full text-center py-8 " + headerBg}>
          <span className="block text-xl text-white font-normal">{title}</span>
          {subTitle && (
            <span className="block text-white text-sm text-opacity-80 mt-3 px-10">
              {subTitle}
            </span>
          )}
        </div>
        <div className="w-full">
          <div className="text-left snap-start px-8 pt-6 pb-8 mb-4 w-full">
            <Form
              onFinish={(values) => {
                if (onSubmit) {
                  onSubmit(values);
                }
              }}
              layout="vertical"
            >
              {children}
              <hr className="mt-36" />
              <div className="mt-8 flex">
                <button
                  type="button"
                  onClick={() => {
                    onClose && onClose();
                  }}
                  className="h-[40px] flex-1 text-[12px] rounded-lg px-4 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 transition-colors duration-200"
                >
                  {t("common.cancel")}
                </button>
                <HButton
                  className="h-[40px] flex-1 ml-3 text-[12px]"
                  type="submit"
                >
                  {t("common.save")}
                </HButton>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default FormModal;
